import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.5 2H12v-.5c0-.83-.67-1.5-1.5-1.5h-2C7.67 0 7 .67 7 1.5V2H3.5C2.67 2 2 2.67 2 3.5v1c0 .63.4 1.2 1 1.41V18.5c0 .83.67 1.5 1.5 1.5h10c.83 0 1.5-.67 1.5-1.5V5.91c.6-.21 1-.78 1-1.41v-1c0-.83-.67-1.5-1.5-1.5zM8 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V2H8v-.5zM14.5 19h-10c-.28 0-.5-.22-.5-.5V6h11v12.5c0 .28-.22.5-.5.5zM16 4.5c0 .28-.22.5-.5.5h-12c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h12c.28 0 .5.22.5.5v1z',
    'M12.5 7c-.28 0-.5.22-.5.5v10c0 .28.22.5.5.5s.5-.22.5-.5v-10c0-.28-.22-.5-.5-.5zM9.5 7c-.28 0-.5.22-.5.5v10c0 .28.22.5.5.5s.5-.22.5-.5v-10c0-.28-.22-.5-.5-.5zM6.5 7c-.28 0-.5.22-.5.5v10c0 .28.22.5.5.5s.5-.22.5-.5v-10c0-.28-.22-.5-.5-.5z',
  ],
  height: 20,
  width: 20,
});
